import React, {Component} from 'react';
import {Col, Row} from 'reactstrap';
import PropTypes from "prop-types";
import {Calculator} from "./Calculator";
import {InputField} from "./InputField";
import {Strings} from "./Strings";
import {Constants} from "./Constants";

export class InputBlock extends Component {


    constructor(props) {
        super(props);
        this.valveDimensionChange = this.valveDimensionChange.bind(this);
        this.valveBoreChange = this.valveBoreChange.bind(this);
        this.inletPressureChange = this.inletPressureChange.bind(this);
        this.outletPressureChange = this.outletPressureChange.bind(this);
        this.flowChange = this.flowChange.bind(this);

        this.valveBoreOptionItems = [
            {value: Constants.REDUCED, name: Strings.inputBoreReduced},
            {value: Constants.FULL, name: Strings.inputBoreFull}];

        this.valveDimensionOptionItems = [];
        for (const dimension in Calculator.kvValues[0]) {
            this.valveDimensionOptionItems.push({value: dimension});
        }
    }

    valveDimensionChange(newValue) {
        let newInputData = this.props.inputData;
        newInputData.valveDimension = Number(newValue);
        this.props.onChange(newInputData);
    }

    valveBoreChange(newValue) {
        let newInputData = this.props.inputData;
        if (Calculator.kvValues[newValue][newInputData.valveDimension] != null) {
            newInputData.valveBore = Number(newValue);
        }
        this.props.onChange(newInputData);
    }

    inletPressureChange(newValue) {
        let newInputData = this.props.inputData;
        newInputData.inletPressure = Number(newValue);
        this.props.onChange(newInputData);
    }

    outletPressureChange(newValue) {
        let newInputData = this.props.inputData;
        newInputData.outletPressure = Number(newValue);
        this.props.onChange(newInputData);
    }


    flowChange(newValue) {
        let newInputData = this.props.inputData;
        newInputData.flow = Number(newValue);
        this.props.onChange(newInputData);
    }

    checkValveDimension() {
        let newInputData = this.props.inputData;
        if (Calculator.kvValues[newInputData.valveBore][newInputData.valveDimension] == null) {
            if (newInputData.valveBore === 0) {
                newInputData.valveBore = 1;
            } else {
                newInputData.valveBore = 0;
            }
            this.props.onChange(newInputData);
        }
    }

    render() {
        const inputData = this.props.inputData;
        this.checkValveDimension();
        return <Row>
            <Col xl="4">
                <InputField prepend={Strings.inputValveDimension} unit={Strings.unitDimension}
                            onChange={this.valveDimensionChange} value={inputData.valveDimension}
                            type="select" options={this.valveDimensionOptionItems} isMissing={false}/>
                <InputField prepend={Strings.inputValveBore} type="select" onChange={this.valveBoreChange}
                            value={inputData.valveBore} options={this.valveBoreOptionItems} isMissing={false}/>
            </Col>
            <Col xl="4">
                <InputField prepend={Strings.inputInPressure} unit={Strings.unitPressure}
                            onChange={this.inletPressureChange} value={inputData.inletPressure} type="number"
                            isMissing={inputData.inletPressure === 0}/>
                <InputField prepend={Strings.inputOutPressure} unit={Strings.unitPressure}
                            onChange={this.outletPressureChange} value={inputData.outletPressure} type="number"
                            isMissing={inputData.outletPressure === 0}/>
            </Col>
            <Col xl="4">
                <InputField prepend={Strings.inputFlow} unit={Strings.unitFlow} onChange={this.flowChange}
                            value={inputData.flow} type="number" isMissing={inputData.flow === 0}/>
            </Col>
            {(!(inputData.inletPressure !== 0 && inputData.outletPressure !== 0 && inputData.flow !== 0)) &&
            <Col>
                <span className="asterisk">*</span> <i className="inputNote">Missing input</i>
            </Col>}
        </Row>;
    }
}

InputBlock.propTypes = {
    inputData: PropTypes.shape({
        flow: PropTypes.number,
        inletPressure: PropTypes.number,
        outletPressure: PropTypes.number,
        valveDimension: PropTypes.number,
        valveBore: PropTypes.number,
        description: PropTypes.string
    }).isRequired,
    onChange: PropTypes.func
};